import axios from 'axios'
var config = require('../../config')

// axios 配置
axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.baseURL = (process.env.NODE_ENV !== 'production' ? config.dev.httpUrl : config.build.httpUrl)

export default axios



// WEBPACK FOOTER //
// ./src/axios/http.js